import { render, staticRenderFns } from "./CreateGroupPopup.vue?vue&type=template&id=198235b3&scoped=true&"
import script from "./CreateGroupPopup.vue?vue&type=script&lang=js&"
export * from "./CreateGroupPopup.vue?vue&type=script&lang=js&"
import style0 from "./CreateGroupPopup.vue?vue&type=style&index=0&id=198235b3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198235b3",
  null
  
)

export default component.exports